// controllers
import { CategoryController } from "controllers";

// HOC
import { withBaseButtonSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";




async function dataStream(callback) {
    const brands = await CategoryController.getCategories();
    callback(sortArrayPipe.transform(brands, 'value'));
  }
  

const CategoriesSelectButtons = withBaseButtonSelect([],dataStream);

export default CategoriesSelectButtons;
